/**
 * Shared frame-merge helpers used by both coachingSessionStore and
 * arcGenerationSessionStore. Walk dotted paths and apply deltas.
 */

/**
 * Walk a dotted path like "proposals.0.title" into an object.
 * Returns [parent, finalKey] so the caller can read or write.
 */
export function walkPath(obj: Record<string, unknown>, dottedPath: string): [unknown, string] {
  const parts = dottedPath.split(".");
  let current: unknown = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    const part = parts[i];
    if (Array.isArray(current)) {
      current = (current as unknown[])[Number(part)];
    } else {
      current = (current as Record<string, unknown>)[part];
    }
  }
  return [current, parts[parts.length - 1]];
}

/**
 * Append a text delta at a dotted path in an object.
 */
export function appendAtPath(obj: Record<string, unknown>, dottedPath: string, delta: string): void {
  const [parent, key] = walkPath(obj, dottedPath);
  if (parent && typeof parent === "object") {
    const p = parent as Record<string, unknown>;
    p[key] = ((p[key] as string) || "") + delta;
  }
}

/**
 * Set a value at a dotted path in an object.
 */
export function setAtPath(obj: Record<string, unknown>, dottedPath: string, value: unknown): void {
  const [parent, key] = walkPath(obj, dottedPath);
  if (parent && typeof parent === "object") {
    (parent as Record<string, unknown>)[key] = value;
  }
}
